import type { PortfolioPad } from '../../lib/portfolioApi';

export type GeoBounds = [number, number, number, number];

export function geometryBounds(geom: GeoJSON.Geometry | null | undefined): GeoBounds | null {
  if (!geom) return null;
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  const walkCoordinates = (coords: unknown): void => {
    if (Array.isArray(coords) && typeof coords[0] === 'number') {
      const [x, y] = coords as number[];
      if (x < minX) minX = x; if (y < minY) minY = y;
      if (x > maxX) maxX = x; if (y > maxY) maxY = y;
    } else if (Array.isArray(coords)) {
      for (const coordinate of coords) walkCoordinates(coordinate);
    }
  };
  const walkGeometry = (value: GeoJSON.Geometry): void => {
    if (value.type === 'GeometryCollection') value.geometries.forEach(walkGeometry);
    else walkCoordinates(value.coordinates);
  };
  walkGeometry(geom);
  return isFinite(minX) ? [minX, minY, maxX, maxY] : null;
}

function unionGeometryBounds(geometries: readonly GeoJSON.Geometry[]): GeoBounds | null {
  let bounds: GeoBounds | null = null;
  for (const geometry of geometries) {
    const next = geometryBounds(geometry);
    if (!next) continue;
    bounds = bounds
      ? [Math.min(bounds[0], next[0]), Math.min(bounds[1], next[1]), Math.max(bounds[2], next[2]), Math.max(bounds[3], next[3])]
      : next;
  }
  return bounds;
}

/** Bounds for the geometry the Crown Pine map currently renders as a selected site. */
export function focusBoundsForPad(
  pad: Pick<PortfolioPad, 'geometry' | 'shortlist'>,
  { buildableHighlight, showEffectiveBuildable }: { buildableHighlight: boolean; showEffectiveBuildable: boolean }
): GeoBounds | null {
  const buildable = pad.shortlist?.buildable;
  const effectivePieces = showEffectiveBuildable ? buildable?.effective?.pieces.features : null;
  const pieces = buildableHighlight
    ? (effectivePieces?.length ? effectivePieces : buildable?.pieces.features)
    : null;
  const pieceBounds = pieces ? unionGeometryBounds(pieces.map(piece => piece.geometry)) : null;
  return pieceBounds ?? geometryBounds(pad.geometry);
}
